import ContentEditor from '@/jquery/widgets/contentEditor'

(function ($) {
  $.Redactor.prototype.consentPreferences = function () {
    return {
      init: function () {
        var $button = this.button.addAfter('personalization', 'consentPreferences', "Consent Preferences");
        this.button.setIcon($button, '<i class="icon iconp-consent"></i>');
        new ContentEditor(
          this.$box, {
            wysiwyg: 'redactor',
            consentPreferences: true,
            consentPreferencesButton: $button
          });
      }
    };
  };
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./vendor/redactor2/custom-plugins/consentPreferences.js
// module id = 85Ey
// module chunks = 40